import React, { memo } from 'react';
import { motion } from 'framer-motion';
export function OpeningHook() {
  return <section className="w-full bg-white py-6 md:py-20 px-4 md:px-6" data-id="element-152">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-153">
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-3 md:mb-6 italic" data-id="element-154">
          Entrás a tu casa después de un día agotador. Abrís la puerta, respirás
          profundo y ahí está: ese olor ácido, punzante y sofocante que ya
          conocés de memoria.
        </p>
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-3 md:mb-6 italic" data-id="element-155">
          Mirás el sofá que todavía estás pagando y ves la mancha húmeda. Sentís
          impotencia, bronca y una culpa enorme por estar enojado con alguien
          que amás.
        </p>
        <p className="text-lg md:text-xl text-[#1C1C1C] leading-relaxed mb-3 md:mb-6 italic" data-id="element-156">
          No sos vos, y no es tu gato "siendo malo". Es un problema de
          comunicación química que tiene solución.
        </p>
      </motion.div>
    </section>;
}